// extracted by mini-css-extract-plugin
module.exports = {"auth0Header":"auth0-header_auth0Header__g4A6k","ad__isMobile":"auth0-header_ad__isMobile__BZ4rS","ad__isDesktop":"auth0-header_ad__isDesktop__1kJYM"};